(function () {
  function setAnswerHeight(answer, open) {
    if (!answer) {
      return;
    }

    if (open) {
      answer.style.height = answer.scrollHeight + 'px';
      return;
    }

    answer.style.height = answer.scrollHeight + 'px';
    answer.offsetHeight;
    answer.style.height = '0px';
  }

  function updateRelativeClasses(items) {
    let openIndex = -1;

    items.forEach(function (item, index) {
      item.classList.remove('above-open', 'below-open');

      if (
        openIndex === -1 &&
        item.classList.contains('is-open')
      ) {
        openIndex = index;
      }
    });

    if (openIndex === -1) {
      return;
    }

    items.forEach(function (item, index) {
      if (index < openIndex) {
        item.classList.add('above-open');
      } else if (index > openIndex) {
        item.classList.add('below-open');
      }
    });
  }

  function closeItem(item) {
    const button = item.querySelector('[data-tcf-toggle]');
    const answer = item.querySelector('.top-concerns-faq__answer');

    if (!button || !answer) {
      return;
    }

    item.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
    setAnswerHeight(answer, false);
  }

  function openItem(item) {
    const button = item.querySelector('[data-tcf-toggle]');
    const answer = item.querySelector('.top-concerns-faq__answer');

    if (!button || !answer) {
      return;
    }

    item.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    setAnswerHeight(answer, true);
  }

  function initTopConcernsFaq(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll(
      '[data-top-concerns-faq]'
    );

    sections.forEach(function (section) {
      if (section.dataset.tcfReady === 'true') {
        return;
      }

      section.dataset.tcfReady = 'true';

      const items = Array.from(
        section.querySelectorAll('.top-concerns-faq__item')
      );

      if (!items.length) {
        return;
      }

      items.forEach(function (item) {
        const button = item.querySelector(
          '[data-tcf-toggle]'
        );
        const answer = item.querySelector(
          '.top-concerns-faq__answer'
        );

        if (!button || !answer) {
          return;
        }

        if (item.classList.contains('is-open')) {
          openItem(item);
        } else {
          answer.style.height = '0px';
        }

        button.addEventListener('click', function () {
          const isOpen = item.classList.contains('is-open');

          items.forEach(function (otherItem) {
            if (otherItem !== item) {
              closeItem(otherItem);
            }
          });

          if (isOpen) {
            closeItem(item);
          } else {
            openItem(item);
          }

          updateRelativeClasses(items);
        });
      });

      updateRelativeClasses(items);

      window.addEventListener('resize', function () {
        items.forEach(function (item) {
          if (!item.classList.contains('is-open')) {
            return;
          }

          const answer = item.querySelector(
            '.top-concerns-faq__answer'
          );

          if (answer) {
            answer.style.height = 'auto';
            answer.style.height =
              answer.scrollHeight + 'px';
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initTopConcernsFaq(document);
      }
    );
  } else {
    initTopConcernsFaq(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initTopConcernsFaq(event.target);
    }
  );
})();
